import React, {Component} from 'react';
import {Box, Typography} from "@material-ui/core";

import SpacerComponent from "../../../Components/SpacerComponent/SpacerComponent";
import {Checkbox} from "@material-ui/core";

class CheckBoxAwardValidationRegistrationFidelityScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            acceptTerm: false,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.award_validation === prevProps.award_validation) {
            return;
        }

        this.setState({
            acceptTerm: this.props.award_validation,
        });
    }

    handleCheckTerm = () => {
        this.setState({
            acceptTerm: !this.state.acceptTerm,
        });
        this.props.onChange(this.state.acceptTerm);
    }

    render() {
        return (
            <Box display={'flex'}
                 flexDirection={'row'}
                 alignItems={'center'}>
                <Checkbox checked={this.state.acceptTerm}
                          onChange={() => this.handleCheckTerm()}
                          color={'primary'}/>
                <SpacerComponent/>
                <Typography variant={'body1'}
                            color={'primary'}>
                    Validar Prêmios Recebidos
                </Typography>
            </Box>
        );
    }
}

export default CheckBoxAwardValidationRegistrationFidelityScreen;